import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { AdminDictionaryProductAttributeResponse } from '@web/shared/module/dictionary';

@jsonObject
export class AdminBoxAttributeResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly value!: string;

  @jsonMember(AdminDictionaryProductAttributeResponse)
  public readonly productAttribute!: AdminDictionaryProductAttributeResponse;
}
